import { Progress } from '@mantine/core';
import { EtaTextOptions } from '@models/Onboarding.model';
import COLORS from '@styles/colors/themes/beam/beam2';
import {
  CompletionPercentageFileCount,
  EstimatedElapsedBox,
  EstimatedElapsedWrapper,
} from './OnboardingPercentage.style';

type CompletionPercentageProps = {
  estimatedTime?: number;
  elapsedTime?: number;
  fileUploadStageText?: EtaTextOptions;
};

export const OnboardingPercentage = ({
  estimatedTime = 0,
  elapsedTime = 0,
  fileUploadStageText,
}: CompletionPercentageProps) => {
  const fileUploadStage = Number(fileUploadStageText?.substring(0, 1));

  const fileCompletionPercentage = (fileUploadStage / 7) * 100;

  const formattedEstimatedTime = (theTime: number) => {
    const mins = Math.floor(theTime / 60);
    const secs = theTime - mins * 60;

    if (mins > 1 && secs > 1) {
      return `${mins}mins ${secs}secs`;
    }
    if (mins < 1 || secs > 1) {
      return `${secs}secs`;
    }
    if (mins > 1 || secs < 2) {
      return `${mins}mins ${secs}sec`;
    }
    return `${mins}min ${secs}sec`;
  };
  return (
    <div>
      <CompletionPercentageFileCount>
        <span>{fileUploadStageText}</span>
        <EstimatedElapsedBox>
          <EstimatedElapsedWrapper>
            <label>Estimate:</label>{' '}
            <span>~{formattedEstimatedTime(estimatedTime)}</span>
          </EstimatedElapsedWrapper>
          <EstimatedElapsedWrapper>
            <label>Elapsed:</label>{' '}
            <span>{formattedEstimatedTime(elapsedTime)}</span>
          </EstimatedElapsedWrapper>
        </EstimatedElapsedBox>
      </CompletionPercentageFileCount>
      {/* progress bar */}
      <Progress
        size="sm"
        sections={[
          {
            value: fileCompletionPercentage,
            color:
              fileCompletionPercentage === 100
                ? `${COLORS.neutral.n300}`
                : `${COLORS.blue.b401}`,
          },
        ]}
      />
    </div>
  );
};
